import React from "react";

import { Typography, Box } from "@mui/material";
import { Variant } from "@mui/material/styles/createTypography";

import { costStyles } from "../styles/themeStyles";

const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

interface CostProps {
  pennies: number;
  variant?: Variant;
  showLabel?: boolean;
}

const Cost = ({ pennies, variant = "body1", showLabel = true }: CostProps) => {
  return (
    <Box component="span" sx={{ display: 'inline-block' }}>
      <Typography variant={variant} title="Current cost based on actual usage">
        {showLabel ? "Current: " : ""}
        {formatter.format(pennies / 100)}
      </Typography>
    </Box>
  );
};

export default Cost;